<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <path
            v-if="weight === 'THIN'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.6249 3.17006C16.8549 3.40006 16.8549 3.78006 16.6249 4.01006L8.63489 12.0001L16.6249 19.9901C16.8549 20.2201 16.8549 20.6001 16.6249 20.8301C16.3949 21.0601 16.0149 21.0601 15.7849 20.8301L7.37489 12.4201C7.14489 12.1901 7.14489 11.8101 7.37489 11.5801L15.7849 3.17006C16.0149 2.94006 16.3949 2.94006 16.6249 3.17006Z"
            fill="currentColor"
        />

        <!-- REGULAR -->
        <path
            v-else-if="weight === 'REGULAR'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.66 3.22988C16.96 3.52988 16.96 4.01988 16.66 4.31988L8.97999 11.9999L16.66 19.6799C16.96 19.9799 16.96 20.4699 16.66 20.7699C16.36 21.0699 15.87 21.0699 15.57 20.7699L7.33999 12.5499C7.03999 12.2499 7.03999 11.7599 7.33999 11.4599L15.56 3.22988C15.86 2.92988 16.35 2.92988 16.65 3.22988H16.66Z"
            fill="currentColor"
        />

        <!-- FILL -->
        <path
            v-else
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.6951 3.27994C17.0651 3.64994 17.0651 4.24994 16.6951 4.61994L9.31509 11.9999L16.6951 19.3799C17.0651 19.7499 17.0651 20.3499 16.6951 20.7199C16.3251 21.0899 15.7251 21.0899 15.3551 20.7199L7.30509 12.6699C6.93509 12.2999 6.93509 11.6999 7.30509 11.3299L15.3551 3.27994C15.7251 2.90994 16.3251 2.90994 16.6951 3.27994Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
    export default {
        name: 'chevron-left-icon',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
